<template>
  <div class="maintain-info-item">
    <div class="index">{{num + 1}}</div>
    <div class="maintain-name" :title="itemName">{{itemName}}</div>
    <div class="big-img-content">
      <img
        v-if="curImg"
        :src="curImg"
        class="big-img"
      >
      <div class="no-big-img">
        <span class="no-img-tips">{{ $t('asm_maintain_info_item.zan_wu_tu_pian') }}</span>
      </div>
    </div>
    <div class="scroll-cutter">
      <div
        class="img-list"
        v-if="imgList.length"
      >
        <div
          v-for="(item, i) in imgList"
          :key="i"
          class="small-img-content"
          :class="i === index ? 'cur' : ''"
          @click="onSel(i)"
        >
          <img
            :src="getAttachUrl(item)"
            class="small-img"
          >
        </div>
      </div>
      <div
        class="file-list"
        v-if="fileList.length"
      >
        <div
          class="file-item"
          v-for="(item,index) in fileList"
          :key="index"
          @click="$downloadFile(getAttachUrl(item))"
        >
          <span>{{item.attachName}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    itemId: [String, Number],
    itemName: String,
    num: Number
  },
  data() {
    return {
      index: 0,
      imgList: [],
      fileList: [],
    };
  },
  computed: {
    curImg() {
      return this.imgList.length ? this.getAttachUrl(this.imgList[this.index]) : '';
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    getImgList() {
      if (this.itemId) {
        this.$getJSON(`${apis.OssAttach}/${this.itemId}/asm.service.item.icon`).then((res) => {
          this.imgList = res.data;
        });
      }
    },
    getFileList() {
      if (this.itemId) {
        this.$getJSON(`${apis.OssAttach}/${this.itemId}/asm.service.item.atlas`).then((res) => {
          this.fileList = res.data;
        });
      }
    },
    onSel(index) {
      this.index = index;
    },
  },
  created() { },
  mounted() {
    this.getImgList();
    this.getFileList();
  },
};
</script>

<style lang="scss">
.maintain-info-item {
  padding: 16px;
  border: 1px solid #ccc;
  width: 250px;
  position: relative;

  > .index {
    $h: 20px;
    $w: 40px;
    border-radius: $h / 2;
    width: $w;
    height: $h;
    background: #00afff;
    line-height: $h;
    text-align: center;
    color: #fff;
    font-size: 14px;
    position: absolute;
    top: $h * -0.5;
    right: $w * -0.5;
  }

  .maintain-name {
    line-height: 40px;
    font-weight: bold;
    text-align: center;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .big-img-content {
    position: relative;
    height: 150px;
    .big-img {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      max-width: 100%;
      max-height: 100%;
    }

    .no-big-img {
      height: 100%;
      background: #f9f9f9;
      text-align: center;
      line-height: 150px;
      .no-img-tips {
        line-height: 30px;
        padding: 0 15px;
        // transform: translate3d(-50%, -50%, 0);
        // position: relative;
        // top: 50%;
        // left: 50%;
      }
    }
  }

  .scroll-cutter {
    height: 120px;
    overflow-y: auto;
    padding: 0 1px;
    .img-list {
      margin-top: 15px;
      .small-img-content {
        position: relative;
        width: 60px;
        height: 60px;
        cursor: pointer;
        margin-right: 10px;
        &.cur {
          box-shadow: 0 0 0 1px #ccc;
        }
        .small-img {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
    }

    .file-list {
      .file-item {
        margin-top: 10px;
        font-size: 12px;
        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
